import api from '@/apis/di/invoiceFormNumberAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid mẫu số hóa đơn
export const useInvoiceFormNumberComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onInvoiceFormNumberComboboxLoadData = (payload, row, column) => {
    payload.sort = 'invoice_form_number_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const invoiceFormNumberComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mẫu số',
        dataField: 'invoice_form_number_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên mẫu số',
        dataField: 'invoice_form_number_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'invoice_form_number_code',
    valueField: 'invoice_form_number_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onInvoiceFormNumberComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    invoiceFormNumberComboConfig,
    onInvoiceFormNumberComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
